// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"24c2ee06","31":"773c36cd","212":"a6ebc395","273":"8e29a410","316":"35fd270a","320":"20a9ec2a","383":"f18810c0","523":"6f609ffb","564":"f2a3c485","582":"3dd05a1b","635":"67fad0a3","943":"8a20e512"}[chunkId] + ".chunk.js";
};